<template>
  <div class="align-records-container">
    <div class="align-records-main">
      <div class="header">
        <div class="header-left">对齐记录</div>
        <div class="header-right" @click="handlePushHome">
          <span>去对齐</span>
          <img class="icon-push" src="~@/assets/imgs/alignment-icons/icon-push.png" alt="">
        </div>
      </div>
      <div class="operation">
        <div class="operation-left">
          <!-- <el-button class="batch-btn download-btn" @click="handleBatchDownload">批量下载</el-button> -->
          <el-button class="batch-btn delete-btn" @click="handleDelete">批量删除</el-button>
        </div>
        <div class="operation-right">
          <el-input size="small" placeholder="输入文件名" v-model="tableQuery.filter.fileName" clearable
                    @clear="getTableData(2)" @keyup.native.enter="getTableData(2)"></el-input>
          <el-button size="small" class="btn-search" icon="el-icon-search" @click="getTableData(2)">
          </el-button>
        </div>
      </div>
      <el-table ref="alignRecordsTable" :data="tableData" border
                header-row-class-name="tabel-header" row-class-name="row-class"
                height="calc(100% - 136px)" style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" width="65" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="fileName" label="文件" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="createTime" label="对齐日期" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sourceLangDesc" label="源语言" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="targetLangDesc" label="目标语言" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sentCount" label="句对数" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{row}">
            <div class="table-operation">
              <el-tooltip effect="dark" content="详情" placement="top-start">
                <i class="table-operation-item icon-view" @click="handleAlignDetail(row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="下载" placement="top-start">
                <el-popover popper-class="align-records-popover" placement="bottom" width="90"
                            trigger="click">
                  <ul class="download-warp">
                    <li class="download-warp-item" v-for="(item,index) in downloadOptions"
                        :key="index" @click="handleDownloadType(item)">
                      {{item.label}}
                    </li>
                  </ul>
                  <i slot="reference" class="table-operation-item icon-download"
                     @click="handleDownload(row)">
                  </i>
                </el-popover>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <i class="table-operation-item icon-delete" @click="handleDelete(row)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-show="pagination.total>0" :layout="pagination.layout"
                  :background="pagination.background" :pager-count="pagination.pagerCount"
                  :total="pagination.total" :page.sync="tableQuery.page"
                  :limit.sync="tableQuery.rows" @pagination="getTableData" />
    </div>
    <!-- 删除弹窗 -->
    <Dialog :dialogVisible="deleteVisible" width="360px" @handleClose="handleDeleteClose"
            @handleConfirm="handleDeleteConfirm">
      <template #title>
        删除
      </template>
      <div class="tips">{{deleteTips}}</div>
    </Dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { removeProperty, deepClone } from '@/utils';
import Dialog from '@/components/Dialog';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import bilingualAlignmentAjax from "@/services/bilingualAlignment"
export default {
  name: 'AlignRecords',
  components: {
    Pagination,
    Dialog
  },
  data() {
    return {
      pagination: {                         // 底部分页器部分配置参数
        layout: 'total, prev, pager, next, jumper',
        total: 0,
      },
      tableQuery: {                        // 分页请求参数
        page: 1,
        rows: 15,
        filter: {
          fileName: ''
        }
      },
      tableData: [],                        // 表格列表数据
      multipleSelectionIdList: [],          // 表格选中项id集合
      deleteVisible: false,
      deleteDialogTitle: '删除',            // 删除弹窗标题
      deleteTips: '确定删除该文件吗？',      // 删除弹窗内容
      deleteId: [],                        // 删除文件的id
      downloadId: null,                    // 下载文件的id
    }
  },
  computed: {
    ...mapGetters('alignRecords', [
      'downloadOptions'
    ])
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    ...mapMutations([
      'SET_SOURCE_LANG', // 设置源语言
      'SET_TARGET_LANG', // 设置目标语言
      'SET_IS_SENT',     // 设置是否对齐
    ]),
    ...mapActions([
      'changeFileNumber', // 改变单文档/双文档
      'saveFileList',     // 保存文件
    ]),
    ...mapActions('alignRecords', [
      'downloadFile',                  // 下载文件
      'updateDownloadLoading',         // 更新下载loading状态值
    ]),
    // 去对齐
    handlePushHome() {
      sessionStorage.setItem('myRadio', 2)
      sessionStorage.setItem('isSent', null)
      this.saveFileList(null)
      this.changeFileNumber(2)
      this.SET_IS_SENT()
      // 去对齐的时候删除本地相关数据
      sessionStorage.removeItem("myFileList")
      sessionStorage.removeItem("sourceLang")
      sessionStorage.removeItem("targetLang")
      sessionStorage.removeItem("aligmentqueryInfo")
      this.$router.push({
        name: 'bilingualAlignment',
        // query: {
        //   isInitAlign: true
        // }
      })
    },
    /**
     * @desc 获取表格列表
     * @param {Number} type 1:正常翻页 2：筛选分页（筛选时，分页需要重新回到第一页） 默认为1（正常翻页）
     */
    async getTableData(type = 1) {
      if (type === 2) {
        this.tableQuery.page = 1
      }
      const params = deepClone(this.tableQuery)
      params.filter = removeProperty(params.filter)
      const { totalRows, success, list } = await bilingualAlignmentAjax.queryBatchRecordPage(params)
      if (!success) return
      this.tableData = list
      this.pagination.total = totalRows
      if (list.length === 0 && this.tableQuery.page > 1) {
        this.tableQuery.page -= 1
        this.getTableData()
      }
      this.$nextTick(() => {
        this.$refs.alignRecordsTable.bodyWrapper.scrollTop = 0
      })
    },
    indexMethod(index) {
      let i = index + 1
      return i < 10 ? `0${i}` : i;
    },
    /**
     * @desc 表格多选触发
     * @param {Array} data 回调数据
     */
    handleSelectionChange(data) {
      this.multipleSelectionIdList = data.map(item => item.id)
    },
    // 查看详情
    handleAlignDetail({ id, groupId, sourceLang, targetLang, alignMode, fileList }) {
      const queryInfo = {
        groupId,
        userLastBatchID: id
      }
      const myFileList = fileList.map((item, index) => {
        return {
          name: item.fileName,
          path: item.filePath,
          uploadType: index === 0 ? 'source' : 'target',
          status: 'success',
          percentage: 100
        }
      })
      this.SET_SOURCE_LANG(sourceLang)
      this.SET_TARGET_LANG(targetLang)
      this.changeFileNumber(alignMode)
      this.saveFileList(myFileList)
      sessionStorage.setItem('myCurrentPage', 1)
      sessionStorage.setItem('myRadio', alignMode)
      sessionStorage.setItem('aligmentqueryInfo', JSON.stringify(queryInfo))
      // sessionStorage.setItem('isdisableStartAlignment', JSON.stringify(true))
      this.$router.push({ name: 'alignRecordsDetail' })
    },
    // // 批量下载
    // handleBatchDownload () {
    // },
    // 下载/批量下载
    async handleDownload({ id }) {
      if (id) {
        this.downloadId = id
      }
    },
    // 点击下载项
    async handleDownloadType({ type }) {
      const params = {
        fileId: this.downloadId,
        type
      }
      await this.downloadFile(params)
      this.downloadId = null
    },

    // 删除/批量删除
    handleDelete({ id }) {
      if (id) {
        this.deleteId.push(id)
        this.deleteDialogTitle = '删除'
        this.deleteTips = '确定删除该文件吗？'
      } else {
        if (this.multipleSelectionIdList.length <= 0) {
          this.$message.closeAll()
          this.$message.warning('请先勾选需要删除的文件')
          return
        }
        this.deleteDialogTitle = '批量删除'
        this.deleteTips = '确定批量删除选中的文件吗？'
      }
      this.deleteVisible = true
    },
    // 取消删除
    handleDeleteClose() {
      this.$refs.alignRecordsTable.clearSelection()
      this.deleteVisible = false
    },
    // 确认删除
    async handleDeleteConfirm() {
      const params = {
        batchIdList: this.deleteId && this.deleteId.length ? this.deleteId : this.multipleSelectionIdList
      }
      const { success } = await bilingualAlignmentAjax.deleteAlignRecord(params)
      if (!success) return
      this.$message.closeAll()
      this.$message.success('删除成功')
      this.deleteId = []
      this.multipleSelectionIdList = []
      this.$refs.alignRecordsTable.clearSelection()
      this.getTableData()
      this.deleteVisible = false
    }
  },
}
</script>

<style lang="less" scoped>
@import "./style/index.less";
</style>
